import cx from "classnames";
import Explanation from "./Explanation";
import styles from "./Paragraphs.module.scss";
import Paragraph2 from "./Paragraph2";
import Image from "@components/Image";
import { usePageContext } from "@providers/PageProvider";
import { brandStoryPage } from "@utils/helper";
import _ from "lodash";

export default function Paragraph() {
  const { pageData } = usePageContext();
  const paragraphs: any = brandStoryPage.formatParagraphs(pageData);
  const logo: any = brandStoryPage.formatLogo(pageData);
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <Explanation />
      {_.map(paragraphs, (paragraph, index) => (
        <Paragraph2
          key={`paragraph_${index}`}
          content={_.get(paragraph, "content", "")}
          image={_.get(paragraph, "image", "")}
        />
      ))}
      <Image
        speed={0}
        wrapperProps={{ className: cx(styles.image) }}
        src={_.get(logo, "src", "") ?? "/brand-story/yellow-bird.svg"}
        alt={_.get(logo, "alt", "") ?? "brand-story-image-logo"}
        layout="fill"
        objectFit="contain"
      />
    </div>
  );
}
